import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import ContractDetails from "../../components/Contracts/ContractDetails";

const ContractsShow = ({contract, backLink}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('contracts.contract_title', {
                person: contract.lecturer.first_name + ' ' + contract.lecturer.last_name,
                course: contract.course.name
            })}
            items={[
                {
                    icon: 'arrow_back',
                    text: i18n.get('default.nav.back'),
                    href: backLink,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(backLink);
                    },
                    color: 'secondary',
                },
                {
                    icon: 'edit',
                    text: i18n.get('contracts.edit'),
                    href: `/contracts/${contract.id}/edit`,
                }
            ]}
        />

                <ContractDetails contract={contract}/>
    </Layout>
);

export default ContractsShow;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/contracts/Show.jsx